"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routesArray = exports.mainNavOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _load = _interopRequireDefault(require("../hocs/load"));
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ProductPositionDetailsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/ProductPositionDetails/ProductPositionDetailsContainer'));
  });
});
var OrderHistoryComponent = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/OrderHistoryComponents'));
  });
});
var FixedLeftFluidLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/FixedLeftFluidLayout/FixedLeftFluidLayout'));
  });
});
var TradingLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/TradingLayout/TradingLayoutContainer'));
  });
});
var BalancesMenuContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/BalancesMenu/BalanceMenuContainer'));
  });
});

// this.t('Trading')
// this.t('Balances')
// this.t('User Settings')
var mainNavOptions = exports.mainNavOptions = {
  mainNavItems: [{
    text: 'Trading',
    icon: 'trading',
    path: '/trading'
  }, {
    text: 'Balances',
    icon: 'balance',
    path: '/balances'
  }, {
    text: 'User Settings',
    icon: 'user-settings',
    path: '/settings/profile'
  }],
  settingsPath: '/settings/profile'
};
var routesArray = exports.routesArray = [{
  path: '/trading',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(TradingLayout, null);
  }
}, {
  path: '/balances',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(FixedLeftFluidLayout, {
      left: [/*#__PURE__*/_react["default"].createElement(BalancesMenuContainer, {
        key: "2"
      })]
    }, /*#__PURE__*/_react["default"].createElement(ProductPositionDetailsContainer, null), /*#__PURE__*/_react["default"].createElement(OrderHistoryComponent, {
      classModifiers: ['full-height'],
      useHeaderWithFilter: true,
      config: {
        maxLines: _config["default"].BalancesLayout.maxLines,
        filterMode: 'selectedProduct',
        usePagination: false
      }
    }));
  }
}];